export default "__VITE_ASSET__DUN5k_Ua__"